module.exports = __webpack_public_path__ + "img/orcish_siege_factory_small.1e0c60dc.png";